module.exports = __webpack_public_path__ + "img/left-arrow.d648020d.svg";